import { type FC } from 'react'

import { ProductBuyBoxIcons } from '../ProductBuyBoxIcons'
import { ProductCarousel } from '../ProductCarousel'
import {
  ProductPageCarouselZoomableImageProvider,
  ProductPageCarouselZoomableImageZoomedImage,
} from '../ProductCarousel/ProductPageCarouselZoomableImage'
import { useProductPageContext } from '../productPageContext'

export const ProductOverviewMediaSection: FC = () => {
  const { currentVariant, product } = useProductPageContext()

  return (
    <div className="relative tablet:w-1/2 tablet:flex-1 tablet:pr-2.5">
      <ProductPageCarouselZoomableImageProvider key={currentVariant.upid}>
        <ProductCarousel productName={product.name} videos={product.videos} />
        {product.images?.length ? (
          <ProductPageCarouselZoomableImageZoomedImage
            alt={product.name}
            className="hidden tablet:block"
          />
        ) : null}
      </ProductPageCarouselZoomableImageProvider>

      <div className="hidden tablet:block">
        <ProductBuyBoxIcons />
      </div>
    </div>
  )
}
